<!--新增行号-->
<template>
  <e-dialog
    :dialog-title="'申请角色'"
    :center-dialog-visible="visible"
    :popup-width="'800px'"
    :button-tip="'提 交'"
    :cancel-button-tip="'关 闭'"
    @resetPopupData="handleCancel"
    @submitPopupData="handleConfirm"
  >
    <div class="role_apply">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="70px"
        label-position="left"
      >
        <el-form-item
          label="提示:"
          label-width="60px"
          class="el-form-item-first"
          >您正在向管理员申请新的角色</el-form-item
        >
        <el-form-item label="申请角色:">
          <div
            v-if="formData.selectionData.length > 1"
            class="role_apply_content"
          >
            共计 <span>{{ formData.selectionData.length }}</span> 个角色
            <span @click="viewRole">查看明细</span>
          </div>
          <div v-else class="role_apply_content">
            <span>{{ formData.selectionData[0]?.roleName }}</span>
          </div>
        </el-form-item>
        <el-form-item label="申请原因:" prop="reason" class="el-form-item-end">
          <el-input
            v-model="formData.reason"
            class="text-area"
            type="textarea"
            maxlength="100"
            show-word-limit
            placeholder="请输入申请原因"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <ViewDialog
      :table-list="tableList"
      :visible="viewRoleDialogShow"
      @close="closeCheckRole"
    ></ViewDialog>
  </e-dialog>
</template>

<script>
import EDialog from '@/components/common/e-dialog.vue';
import ViewDialog from './viewRoleDialog.vue';
import Api from '../../../api/authority';

export default {
  name: 'RoleApplyDialog',
  components: {
    EDialog,
    ViewDialog,
  },
  data() {
    return {
      loading: false,
      visible: false,
      formData: {
        reason: '',
        selectionData: [],
      },
      rules: {
        // reason: [
        //   {
        //     required: true,
        //     message: '请输入申请原因',
        //     trigger: 'blur',
        //   },
        // ],
      },
      tableList: [],
      viewRoleDialogShow: false,
    };
  },
  created() {},

  mounted() {},

  methods: {
    viewRole() {
      this.queryByRoleIdList();
    },
    queryByRoleIdList() {
      const params = {
        roleIdList: this.formData.selectionData.map((item) => item.roleId),
      };
      Api.queryByRoleIdList(params).then((res) => {
        if (res.code === '200') {
          this.tableList = res.data;
          this.viewRoleDialogShow = true;
        }
      });
    },
    closeCheckRole() {
      this.viewRoleDialogShow = false;
    },
    initData(selectionData) {
      this.visible = true;
      this.loading = false;
      this.formData.selectionData = selectionData;
      console.log(this.formData.selectionData);
      // .map((item)=> item.roleId)
    },
    handleCancel() {
      this.visible = false;
      this.formData = {
        reason: '',
        selectionData: [],
      };
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {};
          params.reason = this.formData.reason;
          params.roleIdList = this.formData.selectionData.map(
            (item) => item.roleId
          );
          Api.batchAdd(params).then((res) => {
            if (res.code === '200') {
              this.$message.success('申请中');
              this.visible = false;
              this.$emit('getList');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role_apply {
  :deep(.el-form-item) {
    margin-bottom: 10px;
    white-space: nowrap;
  }
  .el-form-item-first {
    background: rgba(232, 239, 255, 1);
    margin-bottom: 10px;
    :deep(.el-form-item__label) {
      text-align: center;
      color: rgba(240, 37, 15, 1);
    }
  }
  .el-form-item-end {
    :deep(.el-form-item__label) {
      margin-top: -2px;
      // margin-left: -10px;
    }
  }
  .role_apply_content {
    span:nth-child(1) {
      margin: 0 3px;
    }
    span:nth-child(2) {
      color: #2587ff;
      font-size: 13px;
      cursor: pointer;
      margin-left: 3px;
    }
  }
}
</style>
